export default "__VITE_ASSET__86mSW4It__"